import ReservationMaster from '../views/masters/ReservationMaster.vue'
import LocationsMaster from '../views/masters/LocationsMaster.vue'
import OperationsMaster from '../views/masters/OperationsMaster.vue'

import UsersRoles from '../views/settings/UsersRoles.vue'



export default [
    {
        path: '/masters/agents',
        name: 'ReservationMaster',
        component: ReservationMaster
    },
    {
        path: '/masters/locations',
        name: 'LocationsMaster',
        component: LocationsMaster
    },
    {
        path: '/masters/operations',
        name: 'OperationsMaster',
        component: OperationsMaster
    },
    // settings: ["UsersRoles", "Reminders"],
    {
        path: '/settings/users',
        name: 'UsersRoles',
        component: UsersRoles
    },
];